import { render } from "./ManageDemos.vue?vue&type=template&id=f7b6b40a"
import script from "./ManageDemos.vue?vue&type=script&lang=js"
export * from "./ManageDemos.vue?vue&type=script&lang=js"

import "./ManageDemos.vue?vue&type=style&index=0&id=f7b6b40a&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__